type State = Record<string, Record<string, string> | undefined>;

export const withLateTranslation = (
  latest: State,
  clicked: { text: string; hadLang: boolean },
  lang: string,
  key: string,
  translated: string
) =>
  (clicked.hadLang && !(lang in latest)) || latest.de?.[key] !== clicked.text
    ? null
    : { ...latest, [lang]: { ...(latest[lang] ?? {}), [key]: translated } };
